import React, { useState, useRef,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../stateManager/store";
import { updateElement } from "../../../../../stateManager/store/formCreation_v2/actions";
import { ListData } from "./ListData";
import { Panel } from "./Panel";
import { getValue, getComponents } from "../helpers";

export const DataPanel = (props:any) => {
  const labelRef = useRef<any>(null)
  const valueRef = useRef<any>(null)


  const [values, setValues] = useState<any>({
    label: "",
    value: ""
  });
  const dispatch = useDispatch();
  const { selectedElementId } = useSelector((state: AppState) => state.formJson)
  const { components } = getComponents()
  const component = components[selectedElementId]
  const options = component?.properties?.data?.options ?? [];
  const isDataExist = component?.properties?.data;
  const showValidation = component?.properties?.data?.async ?? false;
  const pluginType = component?.type
  const [isKeyFound,setIsKeyFound]=useState(true)

  const handleChange = (e: any) => {
    e.preventDefault();
    const { value, name } = e.target;
    const path = `properties.data.options`
    const options = getValue(component, path.split("."), "") || []
    setValues((prevState: any) => ({ ...prevState, [name]: value }));   
    if (valueRef.current && labelRef.current){
      let duplicateValues=options.filter((f:any)=>{return (f.value === valueRef.current.value || f.label === labelRef.current.value )}); 
      if(duplicateValues.length || !labelRef.current.value || !valueRef.current.value){
        setIsKeyFound(true)
      } else {
        setIsKeyFound(false)
      }
    }
   
  }

  useEffect(()=>{
    if (valueRef.current && labelRef.current){
      let duplicateValues=options.filter((f:any)=>{return (f.value === valueRef.current.value || f.label === labelRef.current.value )});  
      if(duplicateValues.length || !labelRef.current.value || !valueRef.current.value){
        setIsKeyFound(true)
      } else {
        setIsKeyFound(false)
      }
    }
  },[options])

  useEffect(()=>{
    setValues({label:"",value:""})
  },[selectedElementId])
  
  const handleAdd = () => {
    const data = { ...values, id: Math.floor(Math.random() * 100) };
    if(data.value && data.label && !isKeyFound) {
      const path = `properties.data.options`
    const options = getValue(component, path.split("."), "") || []
      onChange([...options, data], path)
      setValues({ label: "", value: "",iconUrl:"" });
    }
    setIsKeyFound(true)
  }

  const onChange = (data: any, key: string) => {
    dispatch(updateElement({
      id: selectedElementId,
      path: key,
      value: data
    }))
  };
  if (!isDataExist) {
    return (
      <div>
        No Data Found
      </div>
    )
  }

  return (
    <>
      <div style={{width: ((pluginType === "Tag" && !showValidation) ? "55px" : "100%")}}>
        <Panel isCheckedIn={props.isCheckedIn} section="data" />
      </div>
      {!showValidation &&
        pluginType !== "ImageViewer" &&
        pluginType !== "PdfViewer" &&
        pluginType !== "ImageSlider" ? 
        pluginType === "Tag" ? (
          <div className="flex items-center justify-end pt-4 flex-wrap">
            <input
              ref={labelRef}
              style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto", width:"116px", height:"28px", borderBottom:"1px solid  rgba(125, 132, 146, 0.294)", borderRadius:"2px" }}
              disabled={!props.isCheckedIn}
              type="text || number"
              name="label"
              className="col-span-2 px-2 bg-white border-gray-300 text-gray-900 text-base focus:outline-none"
              placeholder="Enter label"
              value={values.label}
              onChange={handleChange}
            />
            <input
              ref={valueRef}
              style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto", width:"116px", height:"28px", borderBottom:"1px solid  rgba(125, 132, 146, 0.294)", borderRadius:"2px", marginLeft: "10px" }}
              disabled={!props.isCheckedIn}
              type="text || number"
              name="value"
              className="col-span-2 px-2 bg-white border-gray-300 text-gray-900 text-base focus:outline-none"
              placeholder="Enter value"
              value={values.value}
              onChange={handleChange}
            />
            <input
              style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto", marginTop: "10px", height: "28px", borderBottom: "1px solid  rgba(125, 132, 146, 0.294)", borderRadius: "2px" }}
              disabled={!props.isCheckedIn}
              type="text"
              name="iconUrl"
              className="col-span-2 border-b-2 bg-white border-gray-300 text-gray-900 text-lg w-full px-2 focus:outline-none"
              placeholder="Enter Icon Url"
              value={values.iconUrl}
              onChange={handleChange}
            />
            <button
              disabled={!props.isCheckedIn || isKeyFound}
              style={{
                background: isKeyFound ? "#7D8492B2"
                  : "#052f35 ", cursor: (!props.isCheckedIn || isKeyFound) ? "not-allowed" : "pointer", width: "64px", height: "28px", outline: "none", borderRadius: "3px", marginTop: "15px"
              }}
              className="block text-base font-semibold text-white dark:text-gray-300"
              onClick={handleAdd}
            >
              Add
            </button>
          </div>):
        (<div className="flex items-center justify-between px-1 py-4 flex-wrap">
          <input
            ref={labelRef}
            style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto", width:"85px", height:"28px", borderBottom:"1px solid  rgba(125, 132, 146, 0.294)", borderRadius:"2px" }}
            disabled={!props.isCheckedIn}
            type="text || number"
            name="label"
            className="col-span-2 px-2 bg-white border-gray-300 text-gray-900 text-base focus:outline-none"
            placeholder="Enter label"
            value={values.label}
            onChange={handleChange}
          />
          <input
            ref={valueRef}
            style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto", width:"85px", height:"28px", borderBottom:"1px solid  rgba(125, 132, 146, 0.294)", borderRadius:"2px" }}
            disabled={!props.isCheckedIn}
            type="text || number"
            name="value"
            className="col-span-2 px-2 bg-white border-gray-300 text-gray-900 text-base focus:outline-none"
            placeholder="Enter value"
            value={values.value}
            onChange={handleChange}
          />
          <button
            disabled={!props.isCheckedIn || isKeyFound}
            style={{ background: isKeyFound ? "#7D8492B2"
              :"#052f35 ", cursor: (!props.isCheckedIn || isKeyFound) ? "not-allowed" : "pointer", width:"44px", height:"28px", outline:"none" }}
            className="block text-base font-semibold text-white dark:text-gray-300 rounded-lg"
            onClick={handleAdd}
          >
            Add
          </button>
        </div>) : null}
      <hr style={{ borderTop: "1px dashed #7D84924B", margin:"15px 0px" }} />
      {!showValidation &&
        <div>
          {options.map((option: any, index: number) => (
            <>
            <ListData
              isCheckedIn={props.isCheckedIn}
              data-test-id={`${options}`}
              canEdit={true}
              key={option.id}
              option={option}
              options={options}
              updateOptions={onChange}
              pluginType={pluginType}
            />
            {(pluginType === "Tag" && options.length !== index + 1) && <hr style={{ borderTop: "1px solid #7D84924B", margin: "10px 0px" }} />}
            </>
          ))}
        </div>
      }
    </>
  )
};
